// 서버(utils/libs.js)와 동일한 판정 로직으로 항상 함께 수정한다.

export const BUTTON_LIMITS = { MAX: 5, LABEL_MAX: 20, URL_MAX: 2083 };

const BUTTON_ALLOWED_PROTOCOLS = ['http:', 'https:'];

// utf8mb3 컬럼에 저장할 수 없는 BMP 밖 문자(이모지 등)
const NON_BMP = /[\u{10000}-\u{10FFFF}]/u;

function parseButtonLabel(input) {
  if (typeof input !== 'string') {
    return { valid: false, message: '버튼 문구가 올바르지 않습니다.' };
  }
  const value = input.trim();

  if (!value) {
    return { valid: false, message: '버튼 문구를 입력해 주세요.' };
  }
  if (value.length > BUTTON_LIMITS.LABEL_MAX) {
    return { valid: false, message: `버튼 문구는 ${BUTTON_LIMITS.LABEL_MAX}자 이내로 입력해 주세요.` };
  }
  if (NON_BMP.test(value)) {
    return { valid: false, message: '버튼 문구에 사용할 수 없는 문자(이모지 등)가 포함되어 있습니다.' };
  }
  return { valid: true, value };
}

function parseButtonUrl(input) {
  if (typeof input !== 'string') {
    return { valid: false, message: 'URL이 올바르지 않습니다.' };
  }

  const value = input.trim();

  if (!value) {
    return { valid: false, message: '링크를 입력해 주세요.' };
  }
  if (/\s/.test(value)) {
    return { valid: false, message: 'URL 중간에는 공백을 사용할 수 없습니다.' };
  }
  if (value.length > BUTTON_LIMITS.URL_MAX) {
    return { valid: false, message: `URL 은 ${BUTTON_LIMITS.URL_MAX}자 이내로 입력해 주세요.` };
  }

  let url;
  try {
    url = new URL(value);
  } catch (e) {
    return { valid: false, message: '올바른 URL 형식이 아닙니다.' };
  }

  if (!BUTTON_ALLOWED_PROTOCOLS.includes(url.protocol)) {
    return { valid: false, message: 'http 또는 https 주소만 사용할 수 있습니다.' };
  }
  // https://정상사이트@악성사이트 형태의 피싱을 막는다.
  if (url.username || url.password) {
    return { valid: false, message: 'URL에 사용자 정보를 포함할 수 없습니다.' };
  }

  return { valid: true, value };
}

// 'N' 일 때만 숨김이다. show_yn 이 없는 기존 데이터는 노출로 본다.
function toShowYn(value) {
  return value === 'N' ? 'N' : 'Y';
}

function emptySlot() {
  return { label: '', url: '', show_yn: 'Y' };
}

export function emptySlots() {
  return Array.from({ length: BUTTON_LIMITS.MAX }, emptySlot);
}

export function toSlots(buttons) {
  const slots = emptySlots();
  const list = Array.isArray(buttons) ? buttons : [];

  list.slice(0, BUTTON_LIMITS.MAX).forEach((btn, index) => {
    if (!btn) return;
    slots[index] = {
      label: btn.label || '',
      url: btn.url || '',
      show_yn: toShowYn(btn.show_yn),
    };
  });
  return slots;
}

// 뒤 버튼을 한 칸씩 당기고 마지막에 빈 칸을 채워 5칸을 유지한다.
export function removeSlot(slots, index) {
  slots.splice(index, 1);
  slots.push(emptySlot());
}

export function toPayload(slots) {
  return (slots || [])
      .map((slot) => ({
        label: (slot.label || '').trim(),
        url: (slot.url || '').trim(),
        show_yn: toShowYn(slot.show_yn),
      }))
      .filter((slot) => slot.label && slot.url);
}

export function validateSlots(slots) {
  const errors = [];

  (slots || []).forEach((slot, index) => {
    const label = (slot.label || '').trim();
    const url = (slot.url || '').trim();

    if (!label && !url) return;

    const no = index + 1;
    const labelResult = parseButtonLabel(slot.label);
    const urlResult = parseButtonUrl(slot.url);

    if (!labelResult.valid) errors.push(`${labelResult.message} (${no}번 버튼)`);
    if (!urlResult.valid) errors.push(`${urlResult.message} (${no}번 버튼)`);
  });

  return errors;
}
